import React, { Component, Fragment } from 'react';
import styles from './Header.module.css';
import { connect } from 'react-redux';
import { getUser, logout, getOrganization } from '../../modules/users';
import {
  fetchNotifications,
  getNotifications,
} from '../../modules/notifications';
import PropTypes from 'prop-types';
import Nav from '../../components/Nav';

const catogary = [
  'Home',
  'Dashboard',
  'Collections',
  'Models',
  'Materials',
  'Scenes',
  'Renderings',
];

class Header extends Component {
  state = {
    settingsOpen: false,
  };
  static contextTypes = {
    router: PropTypes.object,
  };

  navTo = (id, cat) => {
    const { router } = this.context;
    const url = `/${cat}${id ? `/${id}` : ''}`;
    router.history.push(url);
  };

  async componentDidMount() {
    //const { fetchNotifications } = this.props;
    //if (fetchNotifications) await fetchNotifications();
  }

  changeSettingState = () => {
    const { settingsOpen } = this.state;
    this.setState({ settingsOpen: !settingsOpen });
  };

  signOut = e => {
    const { logout } = this.props;
    logout().then(() => this.navTo(null, 'login'));
  };

  gotoHomepage = () => {
    this.navTo(null, '');
  };

  gotoProfilePage = () => {
    this.navTo('profile', 'users');
    this.setState({ settingsOpen: false });
  };

  render() {
    const { user, organization, notifications } = this.props;
    const { settingsOpen } = this.state;
    return (
      <Fragment>
        <div className={styles.header}>
          <div className={styles.logoContainer} onClick={this.gotoHomepage}>
            <img
              alt="logo"
              className={styles.logo}
              src={`/img/${(organization && organization.slug) ||
                'login'}logo.png`}
            />
          </div>
          {user && (
            <div
              className={
                settingsOpen ? styles.userSettingsOpen : styles.userSettings
              }
            >
              <div className={styles.avatarContainer}>
                <img
                  alt={user && user.username}
                  src={user.avatar}
                  className={styles.userAvatar}
                />
                <div className={styles.userName}> {user.username} </div>
                <div
                  className={styles.openSettings}
                  onClick={this.changeSettingState}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z" />
                  </svg>
                </div>
              </div>
              {settingsOpen && (
                <div className={styles.userDropDown}>
                  <p
                    className={styles.settingLabel}
                    onClick={this.gotoProfilePage}
                  >
                    My Profile
                  </p>
                  <p className={styles.settingLabel}>My Assignments</p>
                  {/* <p className={styles.settingLabel}>My Notifications</p> */}
                  <p className={styles.settingLabel} onClick={this.signOut}>
                    Sign Out
                  </p>
                </div>
              )}
            </div>
          )}
        </div>
        {user && <Nav catogary={catogary} notifications={notifications} />}
      </Fragment>
    );
  }
}

export default connect(
  state => ({
    user: getUser(state),
    organization: getOrganization(state),
    notifications: getNotifications(state),
  }),
  { logout, fetchNotifications }
)(Header);



// WEBPACK FOOTER //
// ./src/containers/Header/index.js